import React from 'react';
import './modal.scss';
import { Icon } from '../icons';

const Modal = ({ title, children, onClose }) =>
  <div className="modal-container">
    <div className="modal">
      <div className="modal-header">
        <h2>{title}</h2>
        <a className="modal-close" href="#" onClick={onClose}>
          <Icon type={'cross'} className="modal-close-icon"/>
        </a>
      </div>
      <div className="content">
        {children}
      </div>
    </div>
  </div>

export default Modal;



// WEBPACK FOOTER //
// ./src/components/layout/Modal.js